import React from 'react';
import PageHeader from '../components/ui/PageHeader';
import SectionHeading from '../components/ui/SectionHeading';
import Button from '../components/ui/Button';
import SafeIcon from '../common/SafeIcon';
import { FiMapPin, FiPhone, FiMail, FiClock } from 'react-icons/fi';

const Contact = () => {
  return (
    <div className="bg-white min-h-screen">
      <PageHeader title="Contact Us" bgImage="https://images.unsplash.com/photo-1522337360788-8b13dee7a37e?auto=format&fit=crop&q=80&w=2000" />
      
      <div className="container mx-auto px-6 max-w-6xl py-24">
        <SectionHeading title="Get in Touch" subtitle="We'd Love to Hear From You" />
        
        <div className="grid lg:grid-cols-2 gap-16">
          
          {/* Contact Info */}
          <div className="space-y-10">
            <p className="text-lg text-veloura-muted mb-8">
              Have questions about our services or need help booking an appointment? Reach out to our studio team.
            </p>
            
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 bg-veloura-bg rounded-full flex items-center justify-center shrink-0">
                <SafeIcon icon={FiMapPin} className="text-xl text-veloura-accent" />
              </div>
              <div>
                <h4 className="font-serif text-xl text-veloura-text mb-1">Studio Location</h4>
                <p className="text-veloura-muted">1225 Rue Crescent<br/>Montreal, QC H3G 2B1(Demo)<br/>(Near Ste-Catherine St)</p>
              </div>
            </div>

            <div className="flex items-start gap-4">
              <div className="w-12 h-12 bg-veloura-bg rounded-full flex items-center justify-center shrink-0">
                <SafeIcon icon={FiPhone} className="text-xl text-veloura-accent" />
              </div>
              <div>
                <h4 className="font-serif text-xl text-veloura-text mb-1">Phone</h4>
                <p className="text-veloura-muted">(514) 555-1234(Demo)</p>
              </div>
            </div>

            <div className="flex items-start gap-4">
              <div className="w-12 h-12 bg-veloura-bg rounded-full flex items-center justify-center shrink-0">
                <SafeIcon icon={FiMail} className="text-xl text-veloura-accent" />
              </div>
              <div>
                <h4 className="font-serif text-xl text-veloura-text mb-1">Email</h4>
                <p className="text-veloura-muted">hello@velouralashstudio.ca(Demo)</p>
              </div>
            </div>

            <div className="flex items-start gap-4">
              <div className="w-12 h-12 bg-veloura-bg rounded-full flex items-center justify-center shrink-0">
                <SafeIcon icon={FiClock} className="text-xl text-veloura-accent" />
              </div>
              <div>
                <h4 className="font-serif text-xl text-veloura-text mb-1">Hours</h4>
                <p className="text-veloura-muted">Mon-Fri: 10AM - 7PM<br/>Sat: 9AM - 5PM<br/>Sun: Closed</p>
              </div>
            </div>
          </div>

          {/* Contact Form (UI Only) */}
          <div className="bg-veloura-bg p-8 md:p-10 rounded-[2rem]">
            <h3 className="font-serif text-2xl text-veloura-text mb-6">Send a Message</h3>
            <form className="space-y-6" onSubmit={(e) => e.preventDefault()}>
              <div>
                <label className="block text-sm font-medium text-veloura-text mb-2">Name</label>
                <input type="text" className="w-full px-4 py-3 rounded-lg border border-veloura-primary focus:outline-none focus:border-veloura-accent bg-white" placeholder="Jane Doe" />
              </div>
              <div>
                <label className="block text-sm font-medium text-veloura-text mb-2">Email</label>
                <input type="email" className="w-full px-4 py-3 rounded-lg border border-veloura-primary focus:outline-none focus:border-veloura-accent bg-white" placeholder="jane@example.com" />
              </div>
              <div>
                <label className="block text-sm font-medium text-veloura-text mb-2">Message</label>
                <textarea rows="4" className="w-full px-4 py-3 rounded-lg border border-veloura-primary focus:outline-none focus:border-veloura-accent bg-white" placeholder="How can we help you?"></textarea>
              </div>
              <Button type="button" variant="primary" className="w-full py-4">Send Message(Demo)</Button>
            </form>
          </div>

        </div>
      </div>
    </div>
  );
};

export default Contact;